export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE"
export const CHANGE_PRODUCTS = "CHANGE_PRODUCTS"
export const CHANGE_CATEGORIES = "CHANGE_CATEGORIES"
export const CHANGE_TOKEN = "CHANGE_TOKEN"
export const CHANGE_USER_DETAILS = "CHANGE_USER_DETAILS"
export const CHANGE_CART_ITEMS = "CHANGE_CART_ITEMS"
export const CHANGE_SETTINGS = "CHANGE_SETTINGS"